import { render, staticRenderFns } from "./SBImageStep.html?vue&type=template&id=0629c5ce&scoped=true&"
import script from "./SBImageStep.ts?vue&type=script&lang=ts&"
export * from "./SBImageStep.ts?vue&type=script&lang=ts&"
import style0 from "./SBImageStep.css?vue&type=style&index=0&id=0629c5ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0629c5ce",
  null
  
)

export default component.exports